import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  CLIENT_ID,
  CLIENT_SECRET,
  DEFAULT_SCOPES,
  REGISTRATE_USER_SUCCESS,
  REGISTRATE_USER_ERROR,
  CLEAR_REGISTRATE_USER,
  VERIFY_REGISTRATION_EMAIL_SUCCESS,
  VERIFY_REGISTRATION_EMAIL_ERROR,
  LOGGED_IN,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  RESET_UNAUTHORIZED,
  FETCH_ME,
  FETCH_ME_ERROR,
  LOGGING_OUT,
  LOGGED_OUT,
  REFRESH_TOKEN,
  REFRESH_TOKEN_ERROR,
  SEND_PASSWORD_RESET_LINK_SUCCESS,
  SEND_PASSWORD_RESET_LINK_ERROR,
  CLEAR_SEND_PASSWORD_RESET_LINK,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CLEAR_RESET_PASSWORD,
  CONFIRMATION_RESENT_SUCCESS,
  CONFIRMATION_RESENT_ERROR,
  CLEAR_CONFIRMATION_RESENT,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_ERROR,
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_ERROR,
  TOGGLE_LIVECHAT,
  SET_ME,
  CHANGE_SHORT_USERNAME_SUCCESS,
  CHANGE_SHORT_USERNAME_ERROR,
  CLEAR_CHANGE_SHORT_USERNAME,
  GENERATE_QRCODE_USER_SUCCESS,
  GENERATE_QRCODE_USER_ERROR,
  CLEAR_GENERATE_QRCODE_USER,
  FETCH_PAGE_BLOCK_ITEMS_LIST,
  FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR,
  CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST,
  APPLY_PAGE_BLOCK_ITEM_DRAG,
  APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR,
  CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_ERROR,
  CLEAR_CHANGE_EMAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CLEAR_CHANGE_PASSWORD,
  CREATE_TOTP_SUCCESS,
  CREATE_TOTP_ERROR,
  CLEAR_CREATE_TOTP,
  DELETE_TOTP_SUCCESS,
  DELETE_TOTP_ERROR,
  CLEAR_DELETE_TOTP,
  FETCH_TWFA_QRCODE_SUCCESS,
  FETCH_TWFA_QRCODE_ERROR,
  CLEAR_FETCH_TWFA_QRCODE,
  ENABLE_TOTP_SUCCESS,
  ENABLE_TOTP_ERROR,
  CLEAR_ENABLE_TOTP,
  FETCH_TWFA_ENABLED_SUCCESS,
  FETCH_TWFA_ENABLED_ERROR,
  CLEAR_FETCH_TWFA_ENABLED,
  VALIDATE_USERNAME_SUCCESS,
  VALIDATE_USERNAME_ERROR,
  CLEAR_VALIDATE_USERNAME,
  SET_LANG_SUCCESS,
  SET_LANG_ERROR,
} from 'redux/users/types';


export const registrateUser = (email, username, password) => baseErrorsHandlerDecorator(
  REGISTRATE_USER_SUCCESS,
  REGISTRATE_USER_ERROR,
  () => restapi.post(
    addLang('users/register/'),
    { email, username, password },
  ),
);

export const clearRegistrateUser = () => (dispatch) => {
  dispatch({
    type: CLEAR_REGISTRATE_USER,
  });
};

export const verifyRegistrationEmail = key => baseErrorsHandlerDecorator(
  VERIFY_REGISTRATION_EMAIL_SUCCESS,
  VERIFY_REGISTRATION_EMAIL_ERROR,
  () => restapi.post(
    addLang('users/register/verify_email/'),
    {
      key,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scopes: DEFAULT_SCOPES,
    },
  ),
);

export const retrieveToken = (email, password, twoFaCode)  => baseErrorsHandlerDecorator(
  LOGGED_IN,
  LOGIN_ERROR,
  () => restapi.post(
    addLang('users/token/'),
    {
      email,
      password,
      token_2fa: twoFaCode,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scopes: DEFAULT_SCOPES,
    },
  ),
);

export const clearLoginError = () => dispatch => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
  });
};

export const resetUnauthorized = () => dispatch => {
  dispatch({
    type: RESET_UNAUTHORIZED,
  });
};

export const fetchMe = (isLoader = true) => baseErrorsHandlerDecorator(
  FETCH_ME,
  FETCH_ME_ERROR,
  () => restapi.get(addLang('users/me/')),
  isLoader,
);

export const logout = logout => baseErrorsHandlerDecorator(
  LOGGING_OUT,
  LOGGING_OUT,
  () => restapi.post(
    addLang('users/token/logout/'),
    {},
  ),
);

export const logoutComplete = () => dispatch => {
  dispatch({
    type: LOGGED_OUT,
  });
};

export const refreshTokenFunc = refreshToken => baseErrorsHandlerDecorator(
  REFRESH_TOKEN,
  REFRESH_TOKEN_ERROR,
  () => restapi.post(
    addLang('users/token/refresh/'),
    {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      refresh_token: refreshToken,
    },
  ),
);

export const sendPasswordResetLink = email => baseErrorsHandlerDecorator(
  SEND_PASSWORD_RESET_LINK_SUCCESS,
  SEND_PASSWORD_RESET_LINK_ERROR,
  () => restapi.post(
    addLang('users/password/recovery/'),
    { email },
  ),
);

export const clearSendPasswordResetLink = () => dispatch => {
  dispatch({
    type: CLEAR_SEND_PASSWORD_RESET_LINK,
  });
};

export const resetPassword = (confirmationKey, password1, password2) => baseErrorsHandlerDecorator(
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  () => restapi.post(
    addLang('users/password/recovery/confirm/'),
    {
      key: confirmationKey,
      new_password1: password1,
      new_password2: password2,
    },
  ),
);

export const clearResetPassword = () => dispatch => {
  dispatch({
    type: CLEAR_RESET_PASSWORD,
  });
};

export const resendEmailConfirmation = email => baseErrorsHandlerDecorator(
  CONFIRMATION_RESENT_SUCCESS,
  CONFIRMATION_RESENT_ERROR,
  () => restapi.post(addLang('users/register/verify_email/resend/'), { email }),
);

export const clearResendEmailConfirmation = () => dispatch => {
  dispatch({
    type: CLEAR_CONFIRMATION_RESENT,
  });
};

export const googleExchangeCode = code => baseErrorsHandlerDecorator(
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_ERROR,
  () => restapi.post(addLang('users/google/'),
    {
      code: code,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scopes: DEFAULT_SCOPES,
    },
  ),
);

export const facebookExchangeCode = code => baseErrorsHandlerDecorator(
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_ERROR,
  () => restapi.post(addLang('users/facebook/'),
    {
      code: code,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scopes: DEFAULT_SCOPES,
    },
  ),
);

export const shopifyExchangeCode = (code, hmac, shop) => baseErrorsHandlerDecorator(
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_ERROR,
  () => restapi.post(addLang('users/shopify/'),
    {
      code,
      hmac,
      shop,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      scopes: DEFAULT_SCOPES,
    },
  ),
);

export const adminSetTokens = (accessToken, refreshToken) => (dispatch) => {
  dispatch({
    type: LOGGED_IN,
    payload: {
      data: {
        access_token: accessToken,
        refresh_token: refreshToken,
      },
    },
  });
};

export const fetchCountries = provider => baseErrorsHandlerDecorator(
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_ERROR,
  () => restapi.get(addLang(`users/countries/${provider ? `?provider=${provider}` : ''}`)),
  false,
);

export const toggleLivechat = (show=true) => (dispatch) => {
  dispatch({
    type: TOGGLE_LIVECHAT,
    payload: {
      data: {
        show
      },
    },
  });
};

export const setMe = (me) => (dispatch) => {
  dispatch({
    type: SET_ME,
    payload: {
      data: me,
    },
  });
};

export const changeShortUsername = shortcode => baseErrorsHandlerDecorator(
  CHANGE_SHORT_USERNAME_SUCCESS,
  CHANGE_SHORT_USERNAME_ERROR,
  () => restapi.post(
    addLang('users/update_shortlink/'),
    { shortcode }
  ),
  false,
);

export const clearChangeShortUsername = () => dispatch => {
  dispatch({
    type: CLEAR_CHANGE_SHORT_USERNAME,
  });
};

export const generateUserQrCode = () => baseErrorsHandlerDecorator(
  GENERATE_QRCODE_USER_SUCCESS,
  GENERATE_QRCODE_USER_ERROR,
  () => restapi.post(addLang('users/generate-qrcode/')),
  false,
);

export const clearGenerateUserQrCode = () => dispatch => {
  dispatch({
    type: CLEAR_GENERATE_QRCODE_USER,
  });
};

export const fetchPageBlockItemsList = () => baseErrorsHandlerDecorator(
  FETCH_PAGE_BLOCK_ITEMS_LIST,
  FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR,
  () => restapi.get(addLang('users/block_items/')),
  false,
);

export const clearFetchPageBlockItemsList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST,
  });
};

export const applyPageBlockItemsDrag = formData => baseErrorsHandlerDecorator(
  APPLY_PAGE_BLOCK_ITEM_DRAG,
  APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR,
  () => restapi.post(addLang('users/block_items/ordering/'), formData),
  false,
  true,
);

export const clearPageBlockItemsDrag = () => dispatch => {
  dispatch({
    type: CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG,
  });
};

export const changeEmail = formData => baseErrorsHandlerDecorator(
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_ERROR,
  () => restapi.patch(addLang('users/change_email/'), formData),
  false,
  true,
);

export const clearChangeEmail = () => dispatch => {
  dispatch({
    type: CLEAR_CHANGE_EMAIL,
  });
};

export const changePassword = formData => baseErrorsHandlerDecorator(
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  () => restapi.patch(addLang('users/change_password/'), formData),
  false,
  true,
);

export const clearChangePassword = () => dispatch => {
  dispatch({
    type: CLEAR_CHANGE_PASSWORD,
  });
};

export const createTotp = () => baseErrorsHandlerDecorator(
  CREATE_TOTP_SUCCESS,
  CREATE_TOTP_ERROR,
  () => restapi.get(addLang('users/totp/create/')),
  false,
);

export const clearCreateTotp = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_TOTP,
  });
};

export const deleteTotp = () => baseErrorsHandlerDecorator(
  DELETE_TOTP_SUCCESS,
  DELETE_TOTP_ERROR,
  () => restapi.delete(addLang('users/totp/delete/')),
  false,
);

export const clearDeleteTotp = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_TOTP,
  });
};

export const fetchTwoFactorCode = () => baseErrorsHandlerDecorator(
  FETCH_TWFA_QRCODE_SUCCESS,
  FETCH_TWFA_QRCODE_ERROR,
  () => restapi.get(addLang('users/totp/two_fa_qr_code_key/')),
  false,
);

export const clearFetchTwoFactorCode = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_TWFA_QRCODE,
  });
};

export const enableTotp = token => baseErrorsHandlerDecorator(
  ENABLE_TOTP_SUCCESS,
  ENABLE_TOTP_ERROR,
  () => restapi.post(addLang(`users/totp/login/${token}/`)),
  false,
);

export const clearEnableTotp = () => dispatch => {
  dispatch({
    type: CLEAR_ENABLE_TOTP,
  });
};

export const fetchTwoFaEnabled = email => baseErrorsHandlerDecorator(
  FETCH_TWFA_ENABLED_SUCCESS,
  FETCH_TWFA_ENABLED_ERROR,
  () => restapi.post(
    addLang('users/totp/two_fa_enabled/'),
    { email }
  ),
  false,
);

export const clearFetchTwoFaEnabled = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_TWFA_ENABLED,
  });
};

export const validateUsername = (username, email) => baseErrorsHandlerDecorator(
  VALIDATE_USERNAME_SUCCESS,
  VALIDATE_USERNAME_ERROR,
  () => restapi.post(
    addLang('users/validate-username/'),
    { username, email },
  ),
);

export const clearValidateUsername = () => dispatch => {
  dispatch({
    type: CLEAR_VALIDATE_USERNAME,
  });
};

export const setLang = (lang_code) => baseErrorsHandlerDecorator(
  SET_LANG_SUCCESS,
  SET_LANG_ERROR,
  () => restapi.post(
    addLang('users/set-lang/'),
    { lang_code },
  ),
);
